import api from '@/apis'
import Vuetify from '@/plugins/vuetify'

export default {
  state: {
    visibility: false,
    mode: null, // 'add' or 'edit' or 'reset',
    user: null,
    is_submit_btn_disable: false
  },
  mutations: {
    INIT_USER_MNGT_DIALOG(state, { mode, user = null }) {
      state.visibility = true
      state.mode = mode
      state.user = user
    },
    RESET_USER_MNGT_DIALOG(state) {
      state.visibility = false
      setTimeout(() => {
        state.mode = null
        state.user = null
      }, 500)
    },
    SET_USER_MNGT_DIALOG_IS_SUBMIT_BTN_DISABLE(state, payload) {
      state.is_submit_btn_disable = payload
    }
  },
  actions: {
    async createUser({ rootState, commit, dispatch }, payload) {
      try {
        commit('SET_SNACKBAR', {
          status: true,
          color: 'loading',
          text: Vuetify.locale.t('$vuetify.__SnackBar.adding', Vuetify.locale.t('$vuetify.__General.new') + ' ' + Vuetify.locale.t('$vuetify.__AdminSetting.user')),
          loading: true
        })
        commit('SET_USER_MNGT_DIALOG_IS_SUBMIT_BTN_DISABLE', true)

        const device_id = rootState.auth.selected_device
        const response = await api.addUser({ params: { ...payload, device_id } })
        if (response.data.success) {
          commit('SET_SNACKBAR', {
            status: true,
            color: 'success',
            text: Vuetify.locale.t('$vuetify.__SnackBar.add', Vuetify.locale.t('$vuetify.__AdminSetting.user')),
            icon: 'check',
            timeout: '2000'
          })
          commit('RESET_USER_MNGT_DIALOG')
          dispatch('fetchUserList')
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_USER_MNGT_DIALOG_IS_SUBMIT_BTN_DISABLE', false)
      }
    },
    async updateUser({ rootState, state, commit, dispatch }, payload) {
      try {
        commit('SET_SNACKBAR', {
          status: true,
          color: 'loading',
          text: Vuetify.locale.t('$vuetify.__SnackBar.updating', Vuetify.locale.t('$vuetify.__AdminSetting.user')),
          loading: true
        })
        commit('SET_USER_MNGT_DIALOG_IS_SUBMIT_BTN_DISABLE', true)

        const device_id = rootState.auth.selected_device
        const response = await api.updateUser({ params: { ...payload, device_id, user_id: state.user.user_id } })
        if (response.data.success) {
          commit('SET_SNACKBAR', {
            status: true,
            color: 'success',
            text: Vuetify.locale.t('$vuetify.__SnackBar.update', Vuetify.locale.t('$vuetify.__AdminSetting.user')),
            icon: 'check',
            timeout: '2000'
          })
          commit('RESET_USER_MNGT_DIALOG')
          if (state.mode === 'edit') {
            dispatch('fetchUserList')
          }
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_USER_MNGT_DIALOG_IS_SUBMIT_BTN_DISABLE', false)
      }
    },
    async updateCurrentUserPassword({ state, commit, dispatch }, payload) {
      try {
        commit('SET_SNACKBAR', {
          status: true,
          color: 'loading',
          text: Vuetify.locale.t('$vuetify.__SnackBar.updating', Vuetify.locale.t('$vuetify.__AdminSetting.user')),
          loading: true
        })
        commit('SET_USER_MNGT_DIALOG_IS_SUBMIT_BTN_DISABLE', true)

        const response = await api.updateUserPassword({ params: { ...payload, user_id: state.user.user_id } })
        if (response.data.success) {
          commit('SET_SNACKBAR', {
            status: true,
            color: 'success',
            text: Vuetify.locale.t('$vuetify.__SnackBar.update', Vuetify.locale.t('$vuetify.__AdminSetting.user')),
            icon: 'check',
            timeout: '2000'
          })
          commit('RESET_USER_MNGT_DIALOG')
          if (state.mode === 'edit') {
            dispatch('fetchUserList')
          }
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_USER_MNGT_DIALOG_IS_SUBMIT_BTN_DISABLE', false)
      }
    }
  }
}
